/* eslint-disable default-param-last */
import {
  IS_BULK_ACTIONS_COMPLETED,
  SET_ATLEAST_ONE_IS_SELECTED,
  SET_BULK_ACTIONS_ACTION_BY_SELECT_ALL,
  SET_BULK_ACTIONS_ALERT,
  SET_BULK_ACTIONS_ISSUBMITTING,
  SET_BULK_FOOTER_DATA,
  SET_BULK_FOOTER_SHOW,
  SET_CHECK_FOR_BULK_CHEKBOX,
  SET_DISABLE_FOR_BULK_SELECT_ALL,
  SET_INDETERMINATE_FOR_BULK_CHEKBOX,
  SET_SHOW_BULK_SELECT_CHEKBOX,
  SET_SUBMIT_FOR_BULK_SELECT_ALL,
} from '../types';

const INITIAL_STATE = {
  isBulkActionEnabled: false,
  isActionBySelectAll: false,
  isChecked: false,
  isIndeterminate: false,
  isDisabled: true,
  isSelecting: false,
  isAtleastOneSelected: false,
  isBulkFooterVisible: false,
  bulkFooterInfo: null,
  alert: {
    isAlert: false,
    alertText: null,
  },
  isSubmittingAction: false,
  isBulkActionsCompleted: false,
};

const bulkActionReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_BULK_ACTIONS_ACTION_BY_SELECT_ALL:
      return {
        ...state,
        isActionBySelectAll: action?.payload,
      };

    case SET_SHOW_BULK_SELECT_CHEKBOX:
      return {
        ...state,
        isBulkActionEnabled: !!action?.payload,
      };

    case SET_CHECK_FOR_BULK_CHEKBOX:
      return {
        ...state,
        isChecked: action?.payload,
      };

    case SET_BULK_FOOTER_SHOW:
      return {
        ...state,
        isBulkFooterVisible: action?.payload,
      };

    case SET_BULK_FOOTER_DATA:
      return {
        ...state,
        bulkFooterInfo: action?.payload,
      };

    case SET_INDETERMINATE_FOR_BULK_CHEKBOX:
      return {
        ...state,
        isIndeterminate: action?.payload,
      };

    case SET_DISABLE_FOR_BULK_SELECT_ALL:
      return {
        ...state,
        isDisabled: action?.payload,
      };

    case SET_SUBMIT_FOR_BULK_SELECT_ALL:
      return {
        ...state,
        isSelecting: action?.payload,
      };

    case SET_ATLEAST_ONE_IS_SELECTED:
      return {
        ...state,
        isAtleastOneSelected: action?.payload,
      };

    case SET_BULK_ACTIONS_ALERT:
      return {
        ...state,
        alert: {
          isAlert: action?.payload?.isAlert,
          alertText: action?.payload?.alertText,
        },
      };

    case SET_BULK_ACTIONS_ISSUBMITTING:
      return {
        ...state,
        isSubmittingAction: action?.payload,
      };

    case IS_BULK_ACTIONS_COMPLETED:
      return {
        ...state,
        isBulkActionsCompleted: action?.payload,
      };

    default:
      return state;
  }
};

export default bulkActionReducer;
